import { APP_MANIFEST } from '../../constants';
import { CHANNEL_HUB_SERVICE, IChannel, IChannelHub } from '@alk/channel-hub';
import { fetchJson } from '@alk/core';
import { IChannelConnector } from './channel-connector.interface';
import { ILauncherManifest, IProvider } from '../../interfaces';
import { inject, injectable } from 'inversify';

@injectable()
export class ChannelConnectorService implements IChannelConnector {
    private channel: IChannel;

    @inject(CHANNEL_HUB_SERVICE) private readonly channelHub: IProvider<IChannelHub>;

    private async connectToChannel() {
        const manifest = await fetchJson(APP_MANIFEST) as ILauncherManifest;
        const channelName = manifest?.appConfig?.channelLabel;

        this.channel = await (await this.channelHub()).connectToChannel(channelName) as IChannel;

    }

    async getChannel(): Promise<IChannel> {
        if (!Boolean(this.channel)) {
            await this.connectToChannel();
        }

        return this.channel;
    }
}
